import {
  primaryButtonAnalytics,
  RegionTypes,
} from "components/flexComponents/DestinationHero/DestinationHeroUtilities";
import { EntityType, HeartButton } from "components/shared/HeartButton/HeartButton";
import { UitkPrimaryButton } from "uitk-react-button";
import { useLocalization } from "@shared-ui/localization-context";
import * as React from "react";
import { AnalyticsStore } from "bernie-core";
import { UitkLayoutFlex } from "uitk-react-layout-flex";

export const heartButton = (regionId: string, name: string, regionType: string) => {
  if (!(name && regionId && regionType)) {
    return null;
  }

  const entityType = regionType === RegionTypes.Neighborhood ? EntityType.NEIGHBORHOOD : EntityType.CITY;

  return (
    <HeartButton
      moduleName="TG.LP.Dest.Hero"
      heartableEntity={{
        id: regionId,
        name,
        entityType,
        payload: { favoriteId: regionId },
      }}
    />
  );
};

export const callToActionButtons = (hotelsLink?: string, flightsLink?: string, analytics?: AnalyticsStore) => {
  if (!(hotelsLink && flightsLink)) {
    return null;
  }
  const { formatText } = useLocalization();

  return (
    <UitkLayoutFlex alignItems="end" justifyContent="end">
      {hotelsLink && (
        <UitkPrimaryButton
          text={formatText("destinationHero.findHotels")}
          tag="a"
          href={hotelsLink}
          className="all-r-margin-two"
          analytics={primaryButtonAnalytics("TG.LP.Dest.Snapshot.Hotels", analytics)}
        />
      )}

      {flightsLink && (
        <UitkPrimaryButton
          text={formatText("destinationHero.findFlights")}
          tag="a"
          href={flightsLink}
          analytics={primaryButtonAnalytics("TG.LP.Dest.Snapshot.Flights", analytics)}
        />
      )}
    </UitkLayoutFlex>
  );
};
